<template>
  <app-page-title :color="'sun'">
    <template #pageTitleLeft>
      <h1>Manage Automatic Payments</h1>
    </template>
    <template #pageTitleRight>
      <router-link class="_mls btn --sm" :to="{name: 'billing-overview'}">Billing Home</router-link>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'
  import billing from '@mixins/billing'

  export default {
    mixins: [billing],
    components: {
      AppPageTitle
    }
  }
</script>
